var React = require('react');

function CloseCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30 0C13.43 0 0 13.43 0 30C0 46.57 13.43 60 30 60C46.57 60 60 46.57 60 30C60 13.43 46.57 0 30 0ZM46.78 43.25L43.24 46.79L30.18 33.71L16.86 47.04L13.32 43.5L26.64 30.18L13.23 16.77L16.77 13.23L30.18 26.64L43.34 13.48L46.88 17.02L33.71 30.18L46.78 43.25Z","fill":"#3B3221"}));
}

CloseCircle.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = CloseCircle;

CloseCircle.default = CloseCircle;
